/** Shared transport toolbar chrome (layout). Icon tones use `.tb-icon` / `.active` / `.primary` in `lab.css`. */
export const tbGroup = "relative z-[1] flex flex-wrap items-center gap-[0.3rem]";
export const tbSep = "relative z-[1] min-h-[1.6rem] w-px shrink-0 self-stretch bg-white/10";
